import { createFileRoute } from '@tanstack/react-router';
import { ColorPicker } from '@osd/ui/color-picker';
import { Stack } from '@osd/ui/stack';
import { CodeBlock } from '@osd/ui/code-block';
import { Section } from '@osd/ui/section';

/**
 * /ui/color-picker — live docs for the `ColorPicker` primitive.
 */
export const Route = createFileRoute('/ui/_layout/color-picker')({
  component: ColorPickerPage,
});

function ColorPickerPage() {
  return (
    <Stack gap={6}>
      <Section
        title="ColorPicker"
        hint='native color input + hex text — variant="random" adds a dice button'
      >
        <Stack gap={4}>
          <ColorPicker label="Brand color" defaultValue="#0ea5e9" />
          <ColorPicker label="Accent (random)" defaultValue="#0ea5e9" variant="random" />
        </Stack>
      </Section>

      <Section title="Form states" hint="required + error + disabled">
        <Stack gap={4}>
          <ColorPicker
            label="Brand color"
            required
            error="Pick a colour with enough contrast against the surface"
          />
          <ColorPicker label="Locked in by admin" defaultValue="#0ea5e9" disabled />
        </Stack>
      </Section>

      <Section title="Code example" hint="copy-pasteable usage">
        <Stack gap={5}>
          <CodeBlock
            title="Default — controlled"
            language="tsx"
            code={`const [accent, setAccent] = useState('#0ea5e9');
return <ColorPicker label="Accent" value={accent} onChange={setAccent} />;`}
          />

          <CodeBlock
            title="Default — uncontrolled"
            language="tsx"
            code={`<ColorPicker label="Brand color" defaultValue="#0ea5e9" />`}
          />

          <CodeBlock
            title="Random variant"
            hint="Click the dice button to pick a fresh hex via WebCrypto"
            language="tsx"
            code={`<ColorPicker label="Accent" defaultValue="#0ea5e9" variant="random" />`}
          />

          <CodeBlock
            title="Required + error"
            hint="error prop paints both the swatch and the text input red and exposes a description below"
            language="tsx"
            code={`<ColorPicker
  label="Brand color"
  required
  error="Pick a colour with enough contrast against the surface"
/>`}
          />

          <CodeBlock
            title="Disabled"
            language="tsx"
            code={`<ColorPicker label="Locked in by admin" defaultValue="#0ea5e9" disabled />`}
          />
        </Stack>
      </Section>
    </Stack>
  );
}
